module.exports = __webpack_public_path__ + "static/media/regenerate.565b73e3.svg";